<section class="header">
    <button class="widget-close-btn" mat-icon-button color="primary" data-dismiss="modal" (click)="closeWidget()">
        <mat-icon>close</mat-icon>
    </button>
</section>